export function formatToIndianCurrency(amount) {
    if (isNaN(amount)) return amount;
  
    // Convert to string in case the amount is not in string format
    const amountStr = amount.toString();
    
    // Regular expression to add commas according to the Indian numbering system
    const [integerPart, decimalPart] = amountStr.split(".");
    
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})(?=(\d{2})*[^0-9]|$))/g, ",");
    
    // Join integer and decimal parts back together (if there's a decimal part)
    return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
  }
const baseURL = 'https://edigitalstudio.in/'
export const LOGIN_URL = baseURL + 'v1/api/login.php';
export const LOGOUT_URL = baseURL + 'v1/api/logout.php';
export const CREATE_ORDER_URL = baseURL + 'v1/api/create-order.php';
export const CHANGE_OWNER_URL = baseURL + 'v1/api/change-owner.php';
export const DASHBOARD_URL = baseURL + 'v1/api/dashboard.php';
export const DELETE_ORDER_URL = baseURL + 'v1/api/deleteOrder.php';
export const GET_ALL_USERS_URL = baseURL + 'v1/api/getAllUsers.php';
export const GET_ORDER_URL = baseURL + 'v1/api/order.php';
export const TRACKING_URL = baseURL + 'v1/api/tracking.php';
export const UPDATE_ORDER_URL = baseURL + 'v1/api/update-order.php';